/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import { useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';
import makeCountdownTimerStyling from './makeCountdownTimerStyling';
import { calculateRemainingPages } from './CountdownTimer.helper';

const Timer = (props) => {
  return (
    <SvgIcon viewBox="0 0 12 12" {...props}>
      <path
        d="M6,0c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8H5.6v0.8c0.9,0.1,1.7,0.5,2.3,1l0.5-0.5
	c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1L9,4.5c0.5,0.8,0.8,1.7,0.8,2.6c0,2.7-2.2,4.9-4.9,4.9C2.2,12,0,9.8,0,7.1
	c0-2.4,1.8-4.5,4.1-4.8V1.5H3.8C3.3,1.5,3,1.2,3,0.8C3,0.4,3.3,0,3.8,0H6z M5.4,4.5c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v3
	c0,0.3,0.2,0.6,0.6,0.6c0.3,0,0.6-0.2,0.6-0.6V4.5z"
      />
    </SvgIcon>
  );
};

const CountdownTimer = () => {
  const { currentPage } = useSelector((store) => store.navigation);
  const { pagesWithLoaderComponent, preSubmissionPagesWithQuestions } =
    useSelector((store) => store.paging);
  const { countdownTimerSettings } = useSelector((store) => store.formConfig);
  const { showCpcRecommendations } = useSelector((store) => store.cpcCard);
  const theme = useTheme();
  const styles = makeCountdownTimerStyling({ theme });

  const {
    overallTimePlaceholder,
    remainingTimePlaceholder,
    textBeforeTimePlaceholder,
    isCountdownTimerEnabled,
  } = countdownTimerSettings;

  const isLoaderPage = pagesWithLoaderComponent.includes(currentPage);
  const isPreSubmissionPageWithQuestions =
    preSubmissionPagesWithQuestions.includes(currentPage);

  if (
    !isCountdownTimerEnabled ||
    isLoaderPage ||
    showCpcRecommendations ||
    !isPreSubmissionPageWithQuestions
  ) {
    return null;
  }

  const isFirstQuestion = currentPage === 0;
  const remainingPages = calculateRemainingPages(
    preSubmissionPagesWithQuestions,
    currentPage
  );

  const overallTimeSummary =
    overallTimePlaceholder !== ''
      ? overallTimePlaceholder
      : 'It only takes a minute!';
  const remainingTimeLeftSuffix =
    remainingTimePlaceholder !== ''
      ? remainingTimePlaceholder
      : 'seconds left...';
  const remainingTimeLeftPrefix =
    textBeforeTimePlaceholder !== '' ? textBeforeTimePlaceholder : '';

  return (
    <Typography css={styles.text} data-testid="countdownTimer">
      <Timer css={styles.timer} />
      {isFirstQuestion === true && overallTimeSummary}
      {isFirstQuestion === false && (
        <>
          {remainingTimeLeftPrefix}
          <strong>{(remainingPages + 1) * 5}</strong> {remainingTimeLeftSuffix}
        </>
      )}
    </Typography>
  );
};

export default CountdownTimer;
